import axios from '@/http/axios'

export function getClubInfo () {
  return axios({
    url: 'v1/club_info',
    method: 'get'
  })
}
